import React, { useState, useRef, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { post, handleError } from "../../../shared/HttpReq";
// import { post, handleError } from "../../../shared/useForm";
import { useForm } from "../../../shared/useForm";
import { Toast } from "../../../shared/toaster/Toaster";
import Spinner from "../../../shared/spinner/Spinner";
import Auth from "../../../auth/Auth";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
function AddDetailsModal(props) {
  // const [modal,setModal] = useState(false)
  const [isLoading, setLoading] = useState(false);
  const [toaster, SetToaster] = useState({
    show: false,
    type: "", // type should be "danger" or "success"
    content: "",
  });

  const params = useParams()


  
  const phoneElm = useRef(null);
  const { values, errors, bindField } = useForm({
    validations: {
      phone: {
        minLength: {
          value: 10,
          message: "Phone number must be 10 digits.",
        },
        maxLength: {
          value: 10,
          message: "Phone number must be 10 digits.",
        },
        pattern: {
          value: /^[0-9]*$/,
          message: "Please enter numeric values only.",
        },
        required: {},
      },
      email: {
        pattern: {
          value:
            /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
          message: "Invalid email address.",
        },
        required: {},
      },
    },
  });

  const route = useHistory();

  const UserSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    let res = await fetch(`${process.env.REACT_APP_BASE_URL}/userRegister`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(values),
    });

    if (res.status >= 200 && res.status <= 299) {
      const data = await res.json();

      Auth.login(data);
      cardDetailSubmit();
      // route.push("/CartDetails/" + params.companyId);
      // setOpenModal(false);
      // SetToaster({
      //   show: true,
      //   type: "Success", // type should be "danger" or "success"
      //   content: "Login Successfully",
      // });
    }
    if (res.status >= 400 && res.status <= 499) {
      const data = await res.json();
      SetToaster({
        show: true,
        type: "danger", // type should be "danger" or "success"
        content: data.message,
      });
    }
    // setTimeout(() => {
    //   SetToaster({
    //     show: false,
    //     type: "",
    //     content: "",
    //   });
    // }, 5000);
    // setLoading(false);
  };

  const cardDetailSubmit = async () => {
    setLoading(true);
    let res = await handleError(
      await fetch(
        `${process.env.REACT_APP_BASE_URL}/addCart`,
        await post(props.cardData)
      )
    );
    if (res.status === 200) {
      setLoading(false);
      SetToaster({
        show: true,
        type: "success",
        content: "Added to cart successfully.",
      });
      route.push("/CartDetails/" + params.companyId);
    } else {
      setLoading(false);
      SetToaster({
        show: true,
        type: "danger",
        content: res.errors,
      });
    }
  };

  useEffect(function () {
    phoneElm.current.focus();
  }, []);



  // hidden scrolling when open Any special instructions modal section start

  useEffect(() => {
    document.querySelector("body").classList.add("hidden_modal_body");

    return function () {
      document.querySelector("body").classList.remove("hidden_modal_body");
    };
  }, []);

  // hidden scrolling when open Any special instructions modal section end

  return (
    <>
      {isLoading ? <Spinner /> : null}
      <Toast
        show={toaster.show}
        type={toaster.type}
        content={toaster.content}
        onClose={() =>
          SetToaster({
            show: false,
            type: "",
            content: "",
          })
        }
      />

      <div className="modalbg">
        <div className="modalclose">
          <div className="login_modal" style={{ position: "relative" }}>
            <div className="login_modal-content">
              <div className="content-hd_top">
                <h4 className="everyday_color">User Detail</h4>
              </div>
              <button
                className="remove_modal"
                style={{ position: "absolute", top: "25px", right: "29px" }}
                onClick={() => props.setOpenModal(false)}
              >
                <svg width="25" height="25" viewBox="0 0 25 25">
                  <g transform="translate(-680 -168)">
                    <circle
                      style={{ fill: "#4E74F6" }}
                      cx="12.5"
                      cy="12.5"
                      r="12.5"
                      transform="translate(680 168)"
                    />
                    <g transform="translate(687.243 156.151) rotate(45)">
                      <path
                        style={{
                          fill: "none",
                          stroke: "#fff",
                          strokeLinecap: "square",
                          strokeWidth: "1.3px",
                        }}
                        d="M27,11H14"
                        transform="translate(0 2.5)"
                      />
                      <path
                        style={{
                          fill: "none",
                          stroke: "#fff",
                          strokeLinecap: "square",
                          strokeWidth: "1.3px",
                        }}
                        d="M18,7V20"
                        transform="translate(2.5 0)"
                      />
                    </g>
                  </g>
                </svg>
              </button>
              <div className="content-midd">
                <form className="login_modal_form" onSubmit={UserSubmit}>
                  <div className="input_field">
                    <label htmlFor="#">Phone No.</label>
                    <input
                      type="tel"
                      id="login_mobile"
                      {...bindField("phone")}
                      ref={phoneElm}
                      className="input-txt"
                      placeholder="Please enter your phone number"
                      required
                    />
                    {errors.phone && (
                      <p className="text-danger">{errors.phone}</p>
                    )}
                  </div>
                  <div className="input_field">
                    <label htmlFor="#">Email</label>
                    <input
                      type="email"
                      id="login_email"
                      {...bindField("email")}
                      className="input-txt"
                      placeholder="Please enter your email"
                      required
                    />
                    {errors.email && (
                      <p className="text-danger">{errors.email}</p>
                    )}
                  </div>
                  <div className="login_submit">
                    <button type="submit" className="active blue-bg">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddDetailsModal;
